import { FC, ReactElement, useLayoutEffect } from 'react';
import { useParams, Outlet } from 'react-router-dom';

import { setGlobalStoreKey } from '../../../shared/services/apiClient';

const StoreLayout: FC = (): ReactElement => {
  const { storeKey } = useParams<{ storeKey: string }>();

  // Use useLayoutEffect instead of a side-effect in render body.
  // This executes synchronously early in the render cycle and guarantees API client
  // has context before children run their own async fetching in useEffects.
  useLayoutEffect(() => {
    if (storeKey) {
      setGlobalStoreKey(storeKey);
    }
    return () => {
      setGlobalStoreKey(undefined);
    };
  }, [storeKey]);

  return <Outlet />;
};

export default StoreLayout;
